/* eslint-disable max-len */
import React from 'react';
import PropTypes, {arrayOf, func, bool} from 'prop-types';
import styles from './MediaTags.scss';
import Tag from './Tag';

/**
 * Media tags right panel to edit tags
 *
 *
 * @param {Object} props
 * @returns {JSX.Element}
 * @constructor
 */

export const MediaTagsForm = ({
    tags,
    isEditable,
}) => {
    return (<div className={styles.tagForm}>
        <div>
            <h3>Media Tags</h3>
            <div className={styles.tagList}>
                {tags?.sort((a, b) => a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1).map(el => <div key={JSON.stringify(el)}><Tag {...el} type="regular" included={true} isEditable={isEditable} /></div>)}
            </div>
        </div>
    </div>
    );
};

MediaTagsForm.propTypes = {
    tags: arrayOf({
        name: PropTypes.string,
        dimension: PropTypes.string,
        uuid: PropTypes.string,
        relevance: PropTypes.number,
        included: PropTypes.bool,
        removable: PropTypes.bool,
        userGenerated: PropTypes.bool,
        position: PropTypes.number,
    }).isRequired,
    tagExcludes: arrayOf({
        name: PropTypes.string,
        dimension: PropTypes.string,
        uuid: PropTypes.string,
        relevance: PropTypes.number,
        included: PropTypes.bool,
        removable: PropTypes.bool,
        userGenerated: PropTypes.bool,
        position: PropTypes.number,
    }),
    onSave: func.isRequired,
    isEditable: bool,
};
